import React, { useState } from 'react';
import { Button, Modal } from '@amzn/awsui-components-react';
import { VAULT_SERVICES } from 'src/Ateam-BI/Vault/constants';
import DocumentViewer from 'src/Ateam-BI/Vault/components/DocumentViewer';

const BUILDING_WITH_AI_PDF_PATH = "ai-apps/general/AI_Decision_Tree.pdf";

const BuildingWithAIModal = () => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Button variant="inline-link" onClick={() => setVisible(true)}>
        🚀 Building with AI?
      </Button>
      <Modal
        visible={visible}
        onDismiss={() => setVisible(false)}
        size="max"
        header="🚀 Building with AI?"
      >
        {visible && (
          <div style={{ height: '85vh' }}>
            <DocumentViewer
              contentType="pdf"
              service={VAULT_SERVICES.AI_APP}
              serviceParams={{ file_path: BUILDING_WITH_AI_PDF_PATH }}
              viewType="expandable"
            />
          </div>
        )}
      </Modal>
    </>
  );
};

export default BuildingWithAIModal;
